module.exports = __webpack_public_path__ + "img/eye-open.0d1d652b.svg";